import type uPlot from 'uplot';
import type { ChartTimeSyncPreset } from '../state/store';

export type { ChartTimeSyncPreset };

const TRADING_DAYS_PER_YEAR = 252;

export const RANGE_PRESETS: { id: ChartTimeSyncPreset; label: string; tradingDays: number }[] = [
  { id: 'full', label: 'Full Range', tradingDays: 0 },
  { id: '1Y', label: 'One Year', tradingDays: TRADING_DAYS_PER_YEAR },
  { id: '180D', label: '180 Days', tradingDays: 180 },
  { id: '90D', label: '90 Days', tradingDays: 90 },
  { id: '30D', label: '30 Days', tradingDays: 30 },
];

/**
 * Returns the x scale bounds that were set (so callers can use them before uPlot may have updated chart.scales.x).
 */
export function applyRange(
  chart: uPlot,
  barCount: number,
  preset: ChartTimeSyncPreset,
  rightEdgeIndex?: number
): { min: number; max: number } {
  const lastIdx = barCount - 1;
  const rightIdx = rightEdgeIndex ?? lastIdx;

  if (preset === 'full' || barCount === 0) {
    const min = 0;
    const max = Math.max(0, lastIdx);
    chart.setScale('x', { min, max });
    return { min, max };
  }

  const config = RANGE_PRESETS.find((p) => p.id === preset);
  const windowBars = config?.tradingDays ?? TRADING_DAYS_PER_YEAR;
  const leftIdx = Math.max(0, rightIdx - windowBars + 1);
  chart.setScale('x', { min: leftIdx, max: rightIdx });
  return { min: leftIdx, max: rightIdx };
}
